<jqxLoader #loader [imagePosition]="'top'" [width]="60" [height]="60" [text]="'Espere...'">
</jqxLoader>

<div class="panel panel-primary my-1 mx-auto rounded-3 shadow-lg" style="height: 99%">
    <div class="panel-heading clearfix">
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-5">
                <div class="panel-title pull-left">
                    <span style="font-size: x-large;">Módulos aplicaciones / empresas</span>
                </div>
            </div>
            <div class="col-md-3"></div>
        </div>
    </div>

    <div class="m-2 p-2 rounded-3 borderFilter" style="height: 50px;">
    </div>

    <div class="" style="height: 85%;margin-left: 20px;margin-top:20px;">

        <div class="col-12">
            <!-- <h5>Aplicaciones por empresas</h5> -->
            <jqxGrid #grid [theme]="theme" [width]="'65%'" [height]="440" [source]="dataAdapter" [columnsresize]="true"
                [localization]="langGrid" [filterable]="true" [showfilterrow]="true" [columns]="columns"
                [showrowlines]="false" [showcolumnlines]="true" [pageable]="false" [sortable]="true" [altrows]="true"
                [showstatusbar]="true" [statusbarheight]="20" [showaggregates]="true" [rowsheight]="20"
                [columnsheight]="20" [enabletooltips]="true" [editable]="true" [selectionmode]="'singlecell'"
                [groupable]="true" (onCellendedit)="onCellEndEdit($event)" (onRowclick)="onRowSelect($event)">
            </jqxGrid>
        </div>
        <div style="float: left; margin-left: 0px; margin-top: 5px;">
            <jqxButton style="margin-top: 0px; float: left;" [width]='90' [height]='26' [theme]="theme"
                [imgSrc]='"/assets/images/mas.png"' (onClick)="onCrear()">
                Crear
            </jqxButton>
            <jqxButton style="margin-top: 0px; float: left; margin-left: 10px;" [width]='90' [height]='26'
                [theme]="theme" [imgSrc]='"/assets/images/borrar.png"' (onClick)="onBorrar()">
                Borrar
            </jqxButton>
        </div>
    </div>
</div>

<div *ngIf="mostrarEdit">
    <jqxWindow #formAdd [position]="'center'" [width]="930" [height]="500" [zIndex]="999" [autoOpen]="true"
        [isModal]="false" [showCloseButton]="true" [showCollapseButton]="false" [resizable]="false"
        (onClose)="onCloseAdd()">
        <div class="formHeader" style="overflow-x: hidden;">
            Asignación de Módulos
        </div>
        <div class="form" style="float:left; overflow-x: hidden;">
            <jqxGrid #gridApp style="float: left;" [theme]="theme" [width]="'300px'" [height]="420"
                [source]="dataAdapterApp" [columnsresize]="true" [localization]="langGrid" [filterable]="true"
                [showfilterrow]="true" [columns]="columnsApp" [showrowlines]="false" [showcolumnlines]="true"
                [pageable]="false" [sortable]="true" [altrows]="true" [showstatusbar]="true" [statusbarheight]="20"
                [showaggregates]="true" [rowsheight]="20" [columnsheight]="20" [enabletooltips]="true"
                [editable]="false" [selectionmode]="'singlecell'" (onRowclick)="onRowSelectApp($event)">
            </jqxGrid>
            <jqxGrid #gridEmp style="float: left; margin-left: 5px;" [theme]="theme" [width]="'300px'"
                [height]="420" [source]="dataAdapterEmp" [columnsresize]="true" [localization]="langGrid"
                [filterable]="true" [showfilterrow]="true" [columns]="columnsEmp" [showrowlines]="false"
                [showcolumnlines]="true" [pageable]="false" [sortable]="true" [altrows]="true" [showstatusbar]="true"
                [statusbarheight]="20" [showaggregates]="true" [rowsheight]="20" [columnsheight]="20"
                [enabletooltips]="true" [editable]="false" [selectionmode]="'singlecell'"
                (onRowclick)="onRowSelectEmp($event)">
            </jqxGrid>
            <jqxGrid #gridModulos style="float: left; margin-left: 5px;" [theme]="theme" [width]="'300px'"
                [height]="420" [source]="dataAdapterModulo" [columnsresize]="true" [localization]="langGrid"
                [filterable]="true" [showfilterrow]="true" [columns]="columnsMenu" [showrowlines]="false"
                [showcolumnlines]="true" [pageable]="false" [sortable]="true" [altrows]="true" [showstatusbar]="true"
                [statusbarheight]="20" [showaggregates]="true" [rowsheight]="20" [columnsheight]="20"
                [enabletooltips]="true" [editable]="false" [selectionmode]="'singlecell'"
                (onRowclick)="onRowSelectModulo($event)">
            </jqxGrid>
            <div style="position:absolute; bottom:5px; left:5px; margin-top: 23px; clear: both; ">
                <jqxButton style="float:left" [width]='100' [height]='26' [textImageRelation]='"imageBeforeText"'
                    [textPosition]='"left"' [imgSrc]='"/assets/images/save.png"' [value]='"Guardar"'
                    (onClick)="onGuardar()">
                </jqxButton>
            </div>
        </div>
    </jqxWindow>
</div>